export const pendingChatSuggestionChannelsQueryKey = ["pendingChatSuggestionChannels"] as const;
export const pendingChatAgentSuggestionsQueryKey = ["pendingChatAgentSuggestions"] as const;
